package com.havn.app.features.notifications.presentation

import com.havn.app.core.logging.HavnLogger
import com.havn.app.features.auth.domain.AuthRepository
import com.havn.app.features.auth.domain.AuthState
import com.havn.app.features.notifications.domain.HavnDeviceToken
import com.havn.app.features.notifications.domain.NotificationRepository
import com.havn.app.features.notifications.platform.HavnPushNotifications
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.cancel
import kotlinx.coroutines.launch

class NotificationCoordinator(
    private val authRepository: AuthRepository,
    private val notificationRepository: NotificationRepository,
    private val scope: CoroutineScope = CoroutineScope(SupervisorJob() + Dispatchers.Main)
) {
    private var userId: String? = null
    private var hasPromptedThisSession = false

    init {
        scope.launch {
            authRepository.authState.collect { state ->
                userId = (state as? AuthState.LoggedIn)?.user?.id
                if (state !is AuthState.LoggedIn) {
                    hasPromptedThisSession = false
                }
            }
        }
    }

    fun maybeRequestAfterFirstBusinessAction(hasAnyProperty: Boolean, hasAnyOpenHouse: Boolean) {
        if (hasPromptedThisSession || userId == null || (!hasAnyProperty && !hasAnyOpenHouse)) return
        hasPromptedThisSession = true
        scope.launch {
            HavnPushNotifications.requestPermissionAndToken()
                .onSuccess { registration ->
                    if (registration != null) {
                        notificationRepository.registerDeviceToken(
                            HavnDeviceToken(
                                token = registration.token,
                                platform = registration.platform,
                                deviceName = registration.deviceName,
                                appVersion = registration.appVersion
                            )
                        )
                    }
                }
                .onFailure {
                    HavnLogger.error("Notifications", "Push registration failed", it)
                }
        }
    }

    fun dispose() {
        scope.cancel()
    }
}
